import React from 'react';
import {AccessibleToStudentsRadioGroup} from './AccessibleToStudentsRadioGroup';
import {RESOURCE_FIELD_TOOLTIPS} from '../../../utils/tooltipConstants';

export const AccessibleToStudentsWithInfoRadioGroup = () => {
  return <AccessibleToStudentsRadioGroup infoText={RESOURCE_FIELD_TOOLTIPS.studentFacing} />;
};
